import { CHART_CONFIG } from './types';
import { CURRENCY, currencyToText } from '../../../utils/currency';

export const formatters = {
  createNumber: (locale: string, options: Intl.NumberFormatOptions = {}) => new Intl.NumberFormat(locale, options),

  createDate: (locale: string, options: Intl.DateTimeFormatOptions = {}) => new Intl.DateTimeFormat(locale, options),

  currency: (value: number, locale: string, currency: (typeof CURRENCY)[keyof typeof CURRENCY] = CURRENCY.CAD) => {
    const currencyCode = currencyToText(currency);

    if (currency === CURRENCY.MIXED) {
      const formattedValue = formatters.decimal(value, locale);
      return `${formattedValue} ${currencyCode}`;
    }
    return formatters
      .createNumber(locale, {
        style: 'currency',
        currency: currencyCode,
        currencyDisplay: 'narrowSymbol',
      })
      .format(value);
  },

  percentage: (value: number, locale: string, divideBy100 = true) => {
    return formatters
      .createNumber(locale, {
        style: 'percent',
        minimumFractionDigits: CHART_CONFIG.DEFAULT_FRACTION_DIGITS,
        maximumFractionDigits: CHART_CONFIG.DEFAULT_FRACTION_DIGITS,
      })
      .format(divideBy100 ? value / 100 : value);
  },

  decimal: (value: number, locale: string) => {
    return formatters
      .createNumber(locale, {
        minimumFractionDigits: CHART_CONFIG.DEFAULT_FRACTION_DIGITS,
        maximumFractionDigits: CHART_CONFIG.DEFAULT_FRACTION_DIGITS,
      })
      .format(value);
  },

  date: (timestamp: number, locale: string, includeDay = true) => {
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'long',
    };
    if (includeDay) options.day = 'numeric';

    return formatters.createDate(locale, options).format(new Date(timestamp));
  },

  humanizeTimestamp: (timestamp: number, locale: string): string => {
    return formatters.date(timestamp, locale);
  },
};
